/**
 * Normalizes a media URL from the backend.
 * 
 * In development, Django may return URLs with the internal Docker host (http://web:8000/media/...).
 * In production with S3, it returns full S3 URLs (https://...).
 * 
 * This function ensures the URL works correctly in the browser:
 * - S3 URLs (https://...) are returned as-is
 * - Internal Docker URLs are converted to relative paths that go through the Vite proxy
 * - Relative paths (/media/...) are returned as-is
 */
export function getMediaUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  // Full external URL (S3, etc.) — use as-is
  if (url.startsWith('https://')) return url;

  // Internal Docker URL — strip the host, keep the path
  if (url.startsWith('http://')) {
    try {
      const parsed = new URL(url);
      return parsed.pathname;
    } catch {
      return url;
    }
  }

  // Already a relative path
  return url;
}
